/**
 * @file Vuex Store for drag and drop events of files/texts/links over the Padlet page
 */

import { Module } from 'vuex'
import { RootState } from 'vuexstore/surface/types'

enum DraggedDataType {
  File,
  Link,
  Text,
}

interface DragAndDropEventsState {
  isHandlingDragEvent: boolean
  draggedDataType: DraggedDataType
  dropActionMessage: string
}

const initialState = (): DragAndDropEventsState => {
  return {
    isHandlingDragEvent: false,
    draggedDataType: DraggedDataType.File,
    dropActionMessage: '',
  }
}

const dragAndDropEvents: Module<DragAndDropEventsState, RootState> = {
  namespaced: true,
  state: initialState(),
  getters: {
    isHandlingDragEvent: (state): boolean => state.isHandlingDragEvent,
    draggedDataType: (state): DraggedDataType => state.draggedDataType,
    dropActionMessage: (state): string => state.dropActionMessage,
  },
  mutations: {
    START_HANDLING_DRAG_EVENT(state): void {
      state.isHandlingDragEvent = true
    },
    STOP_HANDLING_DRAG_EVENT(state): void {
      state.isHandlingDragEvent = false
    },
    SET_DRAGGED_DATA_TYPE(state, { newType }: { newType: DraggedDataType }): void {
      state.draggedDataType = newType
    },
    SET_DROP_ACTION_MESSAGE(state, { message }: { message: string }): void {
      state.dropActionMessage = message
    },
  },
  actions: {
    startHandlingDragEvent({ commit }): void {
      commit('START_HANDLING_DRAG_EVENT')
    },
    stopHandlingDragEvent({ commit }): void {
      commit('STOP_HANDLING_DRAG_EVENT')
    },
    setDraggedDataType({ commit }, { newType }: { newType: DraggedDataType }): void {
      commit('SET_DRAGGED_DATA_TYPE', { newType })
    },
    setDropActionMessage({ commit }, { message }: { message: string }): void {
      commit('SET_DROP_ACTION_MESSAGE', { message })
    },
  },
}

export default dragAndDropEvents
export { DraggedDataType, DragAndDropEventsState }
